import React from 'react'

interface PinBoxProps {
  value: string
}

const PinBox: React.FC<PinBoxProps> = ({ value }) => {
  const display = value ? '•' : ''
  return (
    <div className="bg-white text-black text-center border border-gray-200 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-flutter-button focus:ring-offset-2 w-[56px] h-[56px] mx-[clamp(4px,0.5vw,6px)] rounded-[12px] text-[clamp(18px,2vw,24px)] font-['IBM Plex Sans Arabic'] font-medium flex items-center justify-center " style={{ direction: 'ltr' }}>
      <span>{display}</span>
    </div>
  )
}

export default PinBox
